import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { Input, Row, Col, Container } from 'reactstrap';
import { WaterwayTypeVM } from './WaterwayTypeVM';
import './WaterwayType.scss';
interface IWaterwayType{
  saveWaterwayOnSelectWaterwayTypePage:any,
  handleOnClickCloseButtonOnSelectWaterwayTypePage:any}

const WaterwayType = observer((props: IWaterwayType) => {
  const vm = useRef(new WaterwayTypeVM({...props})).current;

  return (
    <Container className="waterway-type-container">
      <Row>
        <Col>
          <div className="rcn-top-nav">
            <ul>
              <li className="summary-tab">
                <button
                  data-testid="waterwaysummarytab"
                  aria-label="Summary"
                  className={""}
                  onClick={() => {}}
                >
                  <strong>Summary</strong>
                </button>
              </li>
            </ul>
          </div>
          <div className="waterway-details">
            <Input
              placeholder="Waterway Name..."
              className=""
              id="name"
              aria-required="true"
              aria-label="Waterway Name"
              name="name"
              value={vm.waterwayName}
              onChange={(e) => vm.handleInputChange(e)}
            />

            <Input
              name="type"
              type="select"
              aria-required="true"
              aria-label="Waterway Type"
              id="waterway-type"
              value={vm.waterwayType}
              onChange={(e) => vm.handleInputChange(e)}
              className="waterway-select"
            >
              <option value="">- Select Waterway Type -</option>
              <option value="Grassed Waterway">Grassed Waterway</option>
              <option value="Lined Waterway">Lined Waterway</option>
            </Input>
          </div>
        </Col>
      </Row>
      <div className="h4 enter-text">
        Please enter your waterway type
      </div>
      <Row className="button-row">
        <Col className="waterway-button-group">
          <button className="usa-button" onClick={vm.close}>Close</button>
          <button 
          type="button" 
          className="usa-button"
          onClick={vm.saveWaterway} 
          disabled={!vm.waterwayName || !vm.waterwayType}>
            Save Waterway
          </button>
        </Col>
      </Row>
    </Container>
  );
});

export const WaterwayTypeComp = WaterwayType;